module.exports = __webpack_public_path__ + "static/img/vegetables.9c4d236.png";


//////////////////
// WEBPACK FOOTER
// ./static/vegetables.png
// module id = eEgA
// module chunks = 1